import { Button, dialog } from "nq-component";
import BaseListPresenter from "../../../base/BaseListPresenter";
import InputFactory from "../../../components/InputFactory";

class LeaveManagementPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase,
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }

  onChangeFilter(type, value, field) {
    // Copy the current filters from the state
    const where = { ...this.view.state.filters };

    // Apply the new filter
    switch (type) {
      case "Pointer":
        if (Object.keys(value).length > 0) {
          where[field] = { id: value.id };
        } else {
          delete where[field]; // Remove filter if no value
        }
        break;
      case "Boolean":
        if (value !== null) {
          where[field] = value;
        } else {
          delete where[field]; // Remove filter if no value
        }
        break;
      default:
        if (value) {
          where[field] = { $regex: value, $options: "i" };
        } else {
          delete where[field]; // Remove filter if no value
        }
    }
    console.log("where: ", this.view.state.filters);
    this.view.setState({ filters: where }, () => {
      this.filterSubmit(this.view.state.filters);
    });
  }

  init() {
    this.limit = 10;
    const empID = this.view.getCurrent().employee.id;
    this.where = { "employee.id": empID };
    this.search = {};
    this.filter = {};
    this.include = ["employee", "leaveType"];
    this.keys = []; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }
  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      // this.objects = this.objects.concat(objects);
      console.log("OBE: ", objects);
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  handleCancelBtn(data) {
    // const dateToDay = new Date();
    // dateToDay.setHours(0, 0, 0, 0);
    // const startDate = new Date(data.startdate);
    // startDate.setHours(0, 0, 0, 0);
    // const endDate = new Date(data.enddate);
    // endDate.setHours(0, 0, 0, 0);
    // if (endDate < dateToDay || endDate < startDate) {
    //   this.view.showError("Date range has already passed.");
    //   return;
    // }
    let cancelReason = "";

    dialog.fire({
      html: (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            this.handleCancelRequest(data, cancelReason);
          }}
        >
          <div className="row p-2">
            <h5 className="text-left">Please input necessary details!</h5>

            <div
              className="col-md-12"
              style={{ width: "100%", margin: "0 auto" }}
            >
              <label className="ms-2 mt-2">
                Reason <span className="text-danger">*</span>
              </label>
              <div className="ms-2 me-2">
                <InputFactory
                  type="String"
                  _type="Text"
                  required={true}
                  onChange={(value) => (cancelReason = value)}
                />
              </div>
            </div>
          </div>
          <hr></hr>

          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              type="button"
              onClick={() => dialog.close()}
            >
              Cancel
            </Button>
            <Button className="btn btn-primary" type="submit">
              Continue
            </Button>
          </div>
        </form>
      ),
      footer: false,
    });
  }

  async handleCancelRequest(object, cancelReason) {
    const collection = this.view.getCollectionName();
    const data = {
      id: object.id,
      oldStatus: object.stats,
      stats: "Cancel Request",
      cancelReason: cancelReason,
    };

    try {
      await this.upsertUseCase.execute(collection, data);
      dialog.close();
      this.view.refetchData();
      this.view.showSuccess("Pending for approval");
    } catch (e) {
      dialog.close();
      this.view.showError("Failed to cancel request. Please try again.");
      console.error("Error: ", e.message || e);
    }
  }
}

export default LeaveManagementPresenter;
